import * as Sentry from '@sentry/react'
import gitInfo from '~root/git-info.json'

export const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate:
      import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate:
      import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    // Release tracking - use git commit hash
    release:
      import.meta.env.VITE_APP_VERSION ||
      `${gitInfo.branch}@${gitInfo.commitHash}`,

    beforeSend(event) {
      // Don't send events in development unless explicitly enabled
      if (
        import.meta.env.MODE === 'development' &&
        !import.meta.env.VITE_SENTRY_DEBUG
      ) {
        return null
      }
      return event
    },
  })
}
